import { render } from "./Champ_Cote_Betrail_Indicatif.vue?vue&type=template&id=5bcdfc5f&scoped=true"
import script from "./Champ_Cote_Betrail_Indicatif.vue?vue&type=script&lang=js"
export * from "./Champ_Cote_Betrail_Indicatif.vue?vue&type=script&lang=js"

import "./Champ_Cote_Betrail_Indicatif.vue?vue&type=style&index=0&id=5bcdfc5f&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcdfc5f"]])

export default __exports__